import "../src/public";
import "chartkick/chart.js"
import '../src/utils/parsley/i18n'
